module.exports = __webpack_public_path__ + "img/mtt_6.5.0e8f6436.png";